<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="saleOrderExportRef" :fields="fields" :title="table_title.title1"
        :show_query_container="false" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" @state_change="state_change" :show_toolbar_button="[0, 0, 0, 0, 1]"
        @tool_invoke="tool_invoke" @current_changed="current_changed" tableref="53c9ba7a337b4666bda67b2bbab770dd">
        <template #toolbar="">
          <el-tooltip content="导入" placement="top" effect="light">
            <div style="display: inline-block">
              <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" accept=".xlsx"
                :on-exceed="exceed" :limit="1" :on-remove="remove" :http-request="uploadFile"
                :before-upload="beforeFileUpload" :show-file-list="false" :file-list="fileList"
                :on-success="successFile">
                <el-button plain type="info" style="width: 55px" class="ml-2"><i
                    class="iconfont icon-export-in"></i></el-button>
                <!-- <div slot="tip" class="el-upload__tip">1次只能上传1个xls文件</div> -->
              </el-upload>
            </div>
          </el-tooltip>
          <el-tooltip content="模板下载" placement="top" effect="light">
            <el-button plain type="info" style="width: 55px" @click="downloadTemplate" class="ml-2"><i
                class="iconfont icon-template"></i>
            </el-button>
          </el-tooltip>

          <!-- <el-tooltip content="copacking" placement="top" effect="light">
            <el-button
              type="info"
              plain
              @click="copackingMethod"
              style="width: 55px"
              class="ml-2 fa fa-copy"
              size="mini"
            ></el-button>
          </el-tooltip> -->
        </template>
        <template #operation>
          <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="saveExport"
            :label="$t('common.save')" class="ml-2">
          </QueryButton>
        </template>
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
import * as SalesOrderExportController from "../../controllers/sd/SalesOrderExportController"
import BaseContainer from "../components/BaseContainer"
import QueryButton from "../components/base/QueryButton"
import TableMain from "../components/table/TableMain"
//import * as InventTableController from "../../controllers/base/InventTableController";
import XLSX from "xlsx"
import * as commonController from "../../controllers/commonController"
import * as base_url from "../../shared/base_url"

// import { delete } from 'vue/types/umd';
export default {
  name: "saleOrderDispatch",
  components: {
    QueryButton,
    BaseContainer,
    TableMain,
  },
  data() {
    return {
      fileList: [],
      table_title: {
        title1: "table_sales_order_import",
      },
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      fields: SalesOrderExportController.fields.default,
      dataList: [],
      base_url: base_url.base_url,
    }
  },
  created() { },
  methods: {
    downloadTemplate() {
      window.location.href =
        this.base_url + "/excel_template/" + "销售订单导入模板20240802.xlsx"
    },
    //copacking
    async copackingMethod() {
      this.msgModal("确定要进行copacking操作吗？").then(async (v) => {
        if (v) {
          let _gt_credit =
            await SalesOrderExportController.methods.pickAndInvoke([{ dataAreaId: "070", accountNum: "" }])
          if (_gt_credit) {
            if (_gt_credit.status != 0) {
              this.msgToasts(this.$t("notify.ax_error") + "：" + _gt_credit.message, "error")
              return
            }
          } else {
            this.msgToasts(this.$t("notify.ax_call_failed"), "error")
            return
          }

          let _result =
            await SalesOrderExportController.methods.copackingMethod()
          if (_result) {
            this.msgToasts("copacking成功!", "success")
          } else {
            this.msgToasts("copacking失败!", "error")
          }
        }
      })
    },
    current_changed(old, current) { },
    tool_invoke(data) { },
    state_change(data, cb) {
      if (data.state === "deleted") {
        this.$refs.saleOrderExportRef.RemoveItems(data.selected_items)
      }
    },
    //上传1个以上文件时弹窗提示错误
    exceed: function () {
      // this.$message.error("最多只能上传1个xls文件");
      this.msgToasts("最多只能上传1个xls文件!", "info")
    },
    //删除
    remove() { },
    successFile() {
      //this.isBusy_table3 = false
    },
    async uploadFile(params) {
      let now_date = await commonController.methods.getServerDateTime()
      now_date = new Date(now_date.today)
      this.$refs.saleOrderExportRef.SetData([])
      this.isBusy_table = true
      let _this = this
      let _file = params.file
      let fileReader = new FileReader()
      fileReader.onload = (ev) => {
        try {
          let data = ev.target.result
          let workbook = XLSX.read(data, {
            type: "binary",
            cellDates: true,
          })
          let fields = []
          let listTable = []
          for (let sheet in workbook.Sheets) {
            if (sheet.indexOf("参考表") > -1) {
              continue
            }

            let sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], {
              defval: "",
            })
            console.log(sheetArray)
            if (sheetArray.length == 0) {
              continue
            }

            let _tmpModel = [
              {
                value: "AccountNum",
                key: "客户编码",
              },
              {
                value: "dataAreaId",
                key: "销售公司",
              },
              {
                value: "ItemId",
                key: "SEI物料编号",
              },
              {
                value: "VariantName",
                key: "变型名称",
              },
              {
                value: "DeliveryDate",
                key: "要求装运日期",
              },
              {
                value: "SalesQty",
                key: "数量",
              },
              {
                value: "SalesPoolId",
                key: "订单类型",
              },
              {
                value: "SalesLine_TEC_CustSalesID",
                key: "客户订单号",
              },
              {
                value: "TEC_OtherInfo",
                key: "其他信息",
              },
              {
                value: "TEC_CommonRemark",
                key: "通用备注",
              },
              {
                value: "SEI_PriceUnitCust",
                key: "客户价格",
              },
              {
                value: "SEI_OrderDateCust",
                key: "客户订单日期",
              },
              {
                value: "SEI_ShippingDateCust",
                key: "客户交期",
              },
            ]
            for (var _fm in _tmpModel) {
              let _field_model = { key: "", label: "" }
              let _key = _tmpModel[_fm].value
              let _label = _tmpModel[_fm].key
              _field_model.label = _label
              _field_model.key = _key
              fields.push(_field_model)
            }
            for (var i = 0, l = sheetArray.length; i < l; i++) {
              let _data = []
              for (var key in sheetArray[i]) {
                if (_.isDate(sheetArray[i][key])) {
                  sheetArray[i][key] = this.$date.addDays(
                    sheetArray[i][key],
                    1
                  )
                }
                _data.push({ key: key, value: sheetArray[i][key] })
              }
              let dif = _.differenceBy(_data, _tmpModel, "key")
              if (dif.length > 0) {
                console.log(dif)
                // this.$message.warning("文件类型不正确！");
                this.msgToasts("文件类型不正确！!", "info")

                return
              }
            }
            listTable = sheetArray.map(function (o) {
              return {
                AccountNum: o["客户编码"],
                dataAreaId: o["销售公司"],
                ItemId: o["SEI物料编号"],
                VariantName: o["变型名称"],
                DeliveryDate: o["要求装运日期"]
                  ? _this.$date.format(
                    new Date(o["要求装运日期"]),
                    "yyyy-MM-dd"
                  )
                  : _this.$date.format(now_date, "yyyy-MM-dd"),
                SalesQty: o["数量"],
                SalesPoolId: o["订单类型"],
                SalesLine_TEC_CustSalesID: o["客户订单号"],
                TEC_OtherInfo: o["其他信息"] ? o["其他信息"] : "",
                TEC_CommonRemark: o["通用备注"] ? o["通用备注"] : "",
                SEI_PriceUnitCust: o["客户价格"],
                SEI_OrderDateCust: o["客户订单日期"]
                  ? _this.$date.format(
                    new Date(o["客户订单日期"]),
                    "yyyy-MM-dd"
                  )
                  : _this.$date.format(now_date, "yyyy-MM-dd"),
                SEI_ShippingDateCust: o["客户交期"]
                  ? _this.$date.format(new Date(o["客户交期"]), "yyyy-MM-dd")
                  : _this.$date.format(now_date, "yyyy-MM-dd"),
              }
            })
            _this.$refs.saleOrderExportRef.SetData(listTable)
          }
        } catch (e) {
          console.log(e)
          // this.$message.warning("文件类型不正确！");
          this.msgToasts("文件类型不正确！!", "info")

          this.isBusy_table = false
        }
      }
      fileReader.readAsBinaryString(_file)
      this.isBusy_table = false
      this.fileList = []
    },
    //before上传
    beforeFileUpload() { },
    //保存
    async saveExport(cb) {
      let _this = this
      if (this.$refs.saleOrderExportRef.my_data.length < 1) {
        cb(false)
        return
      }

      let _bool = true
      //负数检查
      _.each(this.$refs.saleOrderExportRef.my_data, (t) => {
        if (t.SalesQty <= 0 || t.SEI_PriceUnitCust < 0) {
          let item = this.$refs.saleOrderExportRef.my_data[parseInt(t._id)]
          item._rowVariant = "danger"
          item._selected = true
          this.$set(this.$refs.saleOrderExportRef.my_data, t._id, item)
          _bool = false
        }
        if (t.SEI_PriceUnitCust == "") {
          t.SEI_PriceUnitCust = null
        }
      })
      if (!_bool) {
        this.msgToasts("数量和销售价格都必须大于零!", "error")
        cb(false)
        return
      }

      let data = { username: this.$global.global_data.local_username }
      data.data = this.$refs.saleOrderExportRef.my_data

      //信用控制调用
      let company = _.uniqWith(_.map(this.$refs.saleOrderExportRef.my_data, (t) => {
        return { dataAreaId: t.dataAreaId, accountNum: t.AccountNum }
      }), _.isEqual)
      let _gt_credit = await SalesOrderExportController.methods.pickAndInvoke(company)
      if (_gt_credit) {
        if (_gt_credit.status != 0) {
          _this.msgToasts(this.$t("notify.ax_error") + "：" + _gt_credit.message, "error")
          cb(false)
          return
        }
      } else {
        _this.msgToasts(this.$t("notify.ax_call_failed"), "error")
        cb(false)
        return
      }

      //console.log(data);
      //return
      let result = await SalesOrderExportController.methods.SaveSaleOrderExport(
        JSON.stringify(data)
      )
      //console.log(result);
      //console.log(result);
      //console.log(this.$refs.saleOrderExportRef.my_data)
      if (result && result.length > 0) {
        //判断后台是否写入成功
        if (result[0][0].status == 0) {
          this.$refs.saleOrderExportRef.SetData([])
          this.msgToasts(this.$t("notify.import_success"), "success")
          this.$refs.saleOrderExportRef.SetData([])
          cb(true, true)
        } else {
          let str = "<div><strong>" + this.$t("notify.import_failed_error") + "</strong></div>"
          _.each(result[0], (t) => {
            if (
              _.isNull(t.companyName) ||
              _.isNull(t.customerName) ||
              _.isNull(t.dataAreaId) ||
              t.dataAreaId == "" ||
              _.isNull(t.variantId) ||
              _.isNull(t.SalesPool) ||
              t.existsRetailVariantId == 0
            ) {
              console.log(t)
              //标红错误行
              let item = this.$refs.saleOrderExportRef.my_data[parseInt(t._id)]
              item._rowVariant = "danger"
              item._selected = true
              this.$set(this.$refs.saleOrderExportRef.my_data, t._id, item)
              str += this.ErrorMsg(t)
            }
          })
          this.msgToasts(str, "error", 0, true, "notify550")
          cb(false)
          return
        }
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
        cb(false)
      }
    },
    ErrorMsg(data) {
      if (_.isNull(data.variantId)) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.variant_coding") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.customerName)) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.customer") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.companyName)) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.company") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.SalesPool)) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.sales_pool") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (data.existsRetailVariantId == 0) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.invent") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      return ""
    },
    async saveSalesOrder(data) {
      let _result = await SalesOrderExportController.methods.saveSalesOrder(
        data
      )
      if (!_result) {
        // this.$message.warning("导入失败！");
        this.msgToasts("导入失败！", "info")

        return false
      }
      // this.$message.success(this.$t("notify.import_success"));
      this.msgToasts(this.$t("notify.import_success"), "success")

      this.$refs.saleOrderExportRef.SetData([])
      return true
    },
    //获取客户信息
    async getCustInfo() {
      let _result = await SalesOrderExportController.methods.getCustInfo(
        this.dataList
      )
      if (!_result) {
        // this.$message.warning("导入失败,查询客户信息失败！");
        this.msgToasts("查询客户信息失败！", "info")

        return false
      }
      let _this = this
      if (_result.length > 0) {
        if (_result[0].length > 0) {
          for (var i in _this.dataList) {
            let _item = _.find(_result[0], {
              AccountNum: _this.dataList[i].AccountNum.toString(),
            })
            if (_item) {
              _this.dataList[i].CurrencyCode = _item.Currency
              _this.dataList[i].InclTax = _item.InclTax
              _this.dataList[i].TaxGroup = _item.TaxGroup
              _this.dataList[i].SEI_Name = _item.SEI_Name
            } else {
              // this.$message.warning("导入失败,查询客户信息失败！");
              this.msgToasts("导入失败,查询客户信息失败！", "info")

              return false
            }
          }
        }
      }
      return true
    },
    //获取物料信息
    async getNameAlias() {
      let _result = await SalesOrderExportController.methods.getNameAlias(
        this.dataList
      )
      if (!_result) {
        // this.$message.warning("导入失败,查询物料失败！");
        this.msgToasts("导入失败,查询物料失败！", "info")

        return false
      }
      let _this = this
      if (_result.length > 0) {
        if (_result[0].length > 0) {
          for (var i in _this.dataList) {
            let _item = _.find(_result[0], {
              ItemId: _this.dataList[i].ItemId.toString(),
            })
            if (_item) {
              _this.dataList[i].NameAlias = _item.NameAlias
              _this.dataList[i].DW_InventUnitId = _item.DW_InventUnitId
            } else {
              //_this.$message.warning("导入失败,查询物料失败！");
              _this.msgToasts("导入失败,查询物料失败！", "info")

              return false
            }
          }
        }
      }
      return true
    },
    //获取物料报价
    async getInventPrice() {
      this.dataList = this.$refs.saleOrderExportRef.my_data
      let _result = await SalesOrderExportController.methods.getDiscPrice(
        this.dataList
      )
      if (!_result) {
        // this.$message.warning("导入失败,查询区间价格失败！");
        this.msgToasts("导入失败,查询区间价格失败！", "info")

        return false
      }
      let discPrice = []
      for (var i in _result) {
        if (_result[i]) {
          let item = _result[i].Result.Data
          if (item && item.length > 0) {
            let _price_m = item[0][0]
            if (_price_m && !_.isNull(_price_m.price)) {
              discPrice.push(_price_m.price)
            } else {
              discPrice.push(0)
            }
          }
        }
      }
      //合并整理数据
      for (var i = 0; i < discPrice.length; i++) {
        //如果saleprice没有值,则取协议价格
        if (this.dataList[i].SalesPrice == "") {
          this.dataList[i].SalesPrice = discPrice[i]
        }
        this.dataList[i].DiscPrice = discPrice[i]
      }
      return true
    },
  },
}
</script>
